import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from "@angular/core";

@Component({
    selector: "app-context-menu",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./context-menu.component.html",
    styleUrls: ["./context-menu.component.css"],
    standalone: false
})
export class ContextMenuComponent {
    @Input() public items: ContextMenuItem[] = [];

    @ViewChild("container") private _container!: ElementRef;
    private _parent: HTMLElement;

    public constructor(elementRef: ElementRef) {
        this._parent = elementRef.nativeElement.parentElement;

        this._parent.addEventListener("mouseup", e => {
            if (e.button === 2) {
                this.show(e.offsetX, e.offsetY);
            }
        });
    }

    public hide() {
        this._container.nativeElement.style.display = "none";
    }

    public itemClicked(item: ContextMenuItem) {
        if (item.execute) {
            item.execute();
            this.hide();
        }
    }

    public overlayClicked() {
        this.hide();
    }

    public itemIsDivider(item: ContextMenuItem) {
        return item.text === "--";
    }

    private show(x: number, y: number) {
        this._container.nativeElement.style.left = x + "px";
        this._container.nativeElement.style.top = y + "px";
        this._container.nativeElement.style.display = "block";

        if (this._container.nativeElement.offsetLeft + this._container.nativeElement.offsetWidth > this._parent.offsetWidth) {
           this._container.nativeElement.style.left = (this._parent.offsetWidth - this._container.nativeElement.offsetWidth) + "px";
        }
        if (this._container.nativeElement.offsetTop + this._container.nativeElement.offsetHeight > this._parent.offsetHeight) {
            this._container.nativeElement.style.top = (this._parent.offsetHeight - this._container.nativeElement.offsetHeight) + "px";
        }
    }
}

export interface ContextMenuItem {
    text: string;
    execute: () => void;
}
